/* eslint-disable max-len */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@sigatoka/elements'
import style9 from 'style9'

import { Container, Layout } from '@project/components'

const styles = style9.create({
  base: {
    display: 'grid',
    gap: 'var(--size-500)'
  },
  body: {
    display: 'grid',
    gridAutoFlow: 'row',
    gap: 'var(--size-400)',
    alignContent: 'center',
    padding: 'var(--size-600)',
    maxWidth: 800
  },
  location: {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'start',
    gap: 'var(--size-100)'
  },
  links: {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'flex-start',
    gap: 'var(--size-100)'
  }
})

export const ServiceScene = ({
  testID = 'services'
}: Partial<CommonProps>): React.ReactElement => {
  const { t } = useTranslation('home')

  return (
    <Layout testID={testID}>
      <Container testID={`${testID}.container`} className={styles('base')}>
        <Typography
          testID={`${testID}.title`}
          variant={'title'}
          text={t('ContractorTitle', {
            defaultValue: `Contractors`
          })}
        />
        <Typography
          testID={`${testID}.description`}
          text={t('LandingDescription', {
            defaultValue: `Unlocking innovation, one line of code at a time, with our diverse team of tech superheroes and blockchain wizards.
          
          We offer comprehensive software development consultancy services, specializing in web, app, and microservice development, with expertise in blockchain technology, and a talented team of skilled developers, engineers, and business analysts to bring your digital projects to life.`
          })}
        />
        <Typography
          testID={`${testID}.title`}
          variant={'title'}
          text={t('ContractorArtificialIntelligence', {
            defaultValue: `Empowered by AI`
          })}
        />
        <Typography
          testID={`${testID}.description`}
          text={t('LandingDescription', {
            defaultValue: `On average, employees spend 2.5 hours per day searching for information. Specialists with ... are empowered with artificial intelligence technologies to produce 1.45 times the output per day.`
          })}
        />
      </Container>
    </Layout>
  )
}
